import { useState } from 'react';

interface FormDataFields {
  [key: string]: string | File | null;
}

interface UseFormSubmissionReturn {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: string | null;
  submitForm: (data: FormDataFields) => Promise<void>;
  resetForm: () => void;
}

export const useFormSubmission = (): UseFormSubmissionReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitForm = async (data: FormDataFields): Promise<void> => {
    setIsLoading(true);
    setIsError(false);
    setError(null);
    setIsSuccess(false);

try {
  const apiUrl = (import.meta as any).env?.VITE_API_EMAIL_URL;
  const destinatario = data.email as string;

  const assunto =
    `[Site Invictus] ${data.servico || 'Contato'}` +
    (data.nome ? ` - ${data.nome}` : '');

  

  // 🔥 Criar FormData
  const formData = new FormData();

formData.append("Assunto", assunto);
formData.append("Mensagem", data.mensagem || "");
formData.append("Destinatario", destinatario);
formData.append("Nome", data.nome || "");
formData.append("Telefone", data.telefone || "");
formData.append("Empresa", data.empresa || "");
formData.append("Servico", data.servico || "");
formData.append("RecaptchaToken", data.recaptchaToken || "");

if (data.anexo instanceof File) {
  formData.append("Anexo", data.anexo);
}


  //console.log('📧 Enviando para API:', apiUrl, formData);

  const res = await fetch(apiUrl, {
    method: 'POST',
    credentials: 'include',
    body: formData // ❗ Não coloque Content-Type manualmente
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Erro ${res.status}: ${text || res.statusText}`);
  }

  setIsSuccess(true);
  //console.log('✅ Formulário enviado com sucesso!');
  


    } catch (err) {
      setIsError(true);
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
      console.error('❌ Erro no envio do formulário:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setIsLoading(false);
    setIsSuccess(false);
    setIsError(false);
    setError(null);
  };

  return {
    isLoading,
    isSuccess,
    isError,
    error,
    submitForm,
    resetForm
  };
};
export default useFormSubmission;